module.exports = __webpack_public_path__ + "media/images/user-profile-setup-interest-areas-airplane-e4769546.png";